import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { fadeInAndUp } from '../../../constants/keyframes/movement';

interface Props {
	searchLoading: boolean;
}

const StyledWrapper = styled.div`
	animation: ${fadeInAndUp} 400ms ease;
`;

const PlaceholderLoading: FC<Props> = () => {
	return (
		<StyledWrapper>
			<ContentLoader height={247}>
				<rect x="0" y="17" rx="4" ry="4" width="400" height="13" />
				<rect x="0" y="40" rx="3" ry="3" width="400" height="25" />
				<rect x="0" y="70" rx="3" ry="3" width="400" height="25" />
				<rect x="0" y="100" rx="3" ry="3" width="400" height="25" />
				<rect x="0" y="130" rx="3" ry="3" width="400" height="25" />
				<rect x="0" y="160" rx="3" ry="3" width="400" height="25" />
				<rect x="0" y="190" rx="3" ry="3" width="400" height="25" />
			</ContentLoader>
		</StyledWrapper>
	);
};

export default PlaceholderLoading;
